import React from 'react';
import { SingleAuthorTemplate } from '../single-author';
import { getAuthorNameKeyword, getStoryPubKeyword } from '../utils';

import './photo-priority-single-author.m.css';

export function PhotoPrioritySingleAuthorTemplate(props) {
  const photoPriorityPropsObj = Object.assign({}, props, {
    authorNameKeyword: getAuthorNameKeyword(),
    storyPubKeyword: getStoryPubKeyword(),
    hideImage: true
  });

  return <div styleName="photo-priority">
    <SingleAuthorTemplate {...photoPriorityPropsObj} />
  </div>;
}